/* Drop bot submissions of the signup form before Portal sends them.

   partials/email-subscription.hbs carries an off-screen honeypot input. A
   person never fills it; a form-filling bot does. Portal listens for submit on
   the form itself, so a capture-phase listener on the document runs first and
   can stop the event before any request is made.

   The bot is shown Source's ordinary "Email sent" state rather than an error,
   so it has no reason to try again. */
(function () {
    'use strict';

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.hasAttribute || !form.hasAttribute('data-members-form')) {
            return;
        }

        var trap = form.querySelector('[data-hh-honeypot]');
        if (!trap || !trap.value) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        form.classList.add('success');
    }, true);
})();
